import { Popup } from 'components/Popup'
import { Typography } from 'components/Typography'
import { useBankAccountPopup } from './Providers/BankAccountPopupProvider'
import { BUTTON_TYPES, Button } from 'components/Button'
import { BTN_TXT } from 'constants/txt'
import { useCallback } from 'react'
import useRouter from 'hooks/useRouter'
import { getPathWithoutLastUuid } from './helpers'
import {
  getDefaultReceivablePopupTitle,
  OPEN_MOOV_PAYMENT_METHODS_STATE_KEY
} from './constants'

export const CantProceedWithDefaultReceivableAccount = () => {
  const {
    cantProceedWithDefaultReceivableAccountPopup: { state, actions }
  } = useBankAccountPopup()
  const { pathname, navigate } = useRouter()

  const {
    name,
    action,
    onAddBankAccount: onAddBankAccountFromPayload
  } = state.payload

  const onAddBankAccount = useCallback(async () => {
    await onAddBankAccountFromPayload?.()
    actions.close()
    navigate(getPathWithoutLastUuid(pathname), {
      state: { [OPEN_MOOV_PAYMENT_METHODS_STATE_KEY]: true }
    })
  }, [actions, navigate, onAddBankAccountFromPayload, pathname])

  return (
    <Popup
      {...state}
      title={getDefaultReceivablePopupTitle('cantProceed', action)}
      zIndex={10000}
      width={442}
      onCancel={actions.close}
      footer={
        <>
          <Button type={BUTTON_TYPES.DEFAULT} onClick={actions.close} upperCase>
            {BTN_TXT.CANCEL}
          </Button>
          <Button
            type={BUTTON_TYPES.PRIMARY}
            onClick={onAddBankAccount}
            upperCase
          >
            {BTN_TXT.ADD_BANK_ACCOUNT}
          </Button>
        </>
      }
    >
      <Typography.Body1>
        {name} is the only account set up to receive payments. Add another
        receivable account before{' '}
        {action === 'changePurpose' ? 'updating this one' : 'deleting this one'}
        .
      </Typography.Body1>
    </Popup>
  )
}
